import { createContext, useContext } from 'react';

import { WizardStepContextValue } from './types';

const WizardStepContext = createContext<WizardStepContextValue | null>(null);

/**
 * Hook for step content to register dynamic behavior with the wizard.
 * Must be called within a FullPageWizard.
 *
 * @return {WizardStepContextValue} Context value with setNextEnabled, setBackEnabled, and setOnNext
 * @throws {Error} If called outside a FullPageWizard
 */
const useWizardStep = (): WizardStepContextValue => {
  const ctx = useContext(WizardStepContext);
  if (!ctx) {
    throw new Error('useWizardStep must be used within a FullPageWizard');
  }
  return ctx;
};

export { WizardStepContext, useWizardStep };
